export default __webpack_public_path__ + "static/media/startIcon.dfb89829.svg";